import { useEdgeHealthCheck } from './useEdgeDataFetcher'

export default ({ includeManheim, reuse, landingContextHealth } = {}) => {
  // If a health check response from the landingContext is passed in use it, otherwise call the health check
  const [healthCheck] = reuse ? [landingContextHealth] : useEdgeHealthCheck()

  //if base or edge is down return true
  const isIcoDown = healthCheck && ((healthCheck.ico && healthCheck.ico === 'Down') || healthCheck.error)

  //if grade api is down return true
  const isManheimDown = healthCheck && healthCheck.gradeApi && healthCheck.gradeApi === 'Down'

  return includeManheim ? isIcoDown || isManheimDown : isIcoDown
}
